<ng-container *transloco="let t;">
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">{{ t('Document index data modal title - (Document preview) - Index data') }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body py-0 px-0" tabindex="0" ngbAutofocus>
        <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="document_indexDataScrollCont">
            <ng-container *ngIf="(indexData$ | async) as indexData">
                <div class="document_indexDataContainer">
                    <app-skeleton *ngIf="(externalLoader === httpActionState.Busy) || (indexDataRequestState$ | async) === httpActionState.Busy" [loop]="9" [section]="'index_data_model_skeleton'"></app-skeleton>
                    <ng-container *ngIf="(externalLoader === httpActionState.Done) && (indexDataRequestState$ | async) === httpActionState.Done">
                        <div class="table-responsive">
                            <ng-container *ngFor="let rolesData of indexData?.template_roles">
                                @if(rolesData?.recipient_role_detail && rolesData?.recipient_role_detail?.is_sender != 1){
                                <ng-container *ngIf="rolesData.recipient_role_detail.is_sender === 0; else sender">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th colspan="2">{{ rolesData?.role_name }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let fieldsData of rolesData?.personfields">
                                                @if(fieldsData?.is_enable === 1 && !(_globalService$?.name_format === 1 && ['Last name'].includes(fieldsData?.name))){
                                                <ng-container>
                                                    <td>{{ _globalService$?.name_format === 0 && ['Full name'].includes(fieldsData?.name) ? t('First name (general) - First name') : fieldsData?.name }}</td>
                                                    @if(fieldsData?.metadata_type === 'image'){
                                                        <td [innerHTML]="fieldsData | indexDataAttachment : indexData | safe : 'html'"></td>
                                                    } @else {
                                                        <td>{{ fieldsData?.value }}</td>
                                                    }
                                                </ng-container>
                                                } 
                                                @if(['Last name'].includes(fieldsData?.name)){
                                                <ng-container>
                                                    <td>{{ fieldsData?.name }}</td>
                                                    <td>{{ fieldsData?.value }}</td>
                                                </ng-container>
                                                }
                                            </tr>
                                        </tbody>
                                    </table>
                                </ng-container>
                                <ng-template #sender>
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th colspan="2">{{ rolesData?.role_name }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{{ t('Name (general) - Name') }}</td>
                                                <td>{{ rolesData?.user?.name }}</td>
                                            </tr>
                                            <tr>
                                                <td>{{ t('Email (general) - Email') }}</td>
                                                <td>{{ rolesData?.user?.email }}</td>
                                            </tr>
                                            <tr>
                                                <td>{{ t('Phone (general) - Phone') }}</td>
                                                <td>{{ rolesData?.user?.phone }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </ng-template>

                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th font="bold">{{ t('Details tab text (Document index data model) - Details') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let roleData of (rolesData | indexDataPipe | async)">
                                            <td>{{ roleData?.label }}</td>
                                            @if(roleData?.label === 'Authentication'){
                                                <td>{{ roleData?.value | authenticatioType: true }}</td>
                                            } 
                                            @else if(roleData?.label === 'Invitation type'){
                                                <td>{{ roleData?.value | invitationType: true }}</td>
                                            } 
                                            @else {
                                                <td>{{ roleData?.value }}</td>
                                            }
                                        </tr>
                                    </tbody>
                                </table>

                                @if(rolesData?.organization_id) {
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>{{ t('Organizations tab text (Document index data model) - Organizations') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of rolesData?.orgfields">
                                            <ng-container *ngIf="item?.is_enable === 1">
                                                <td>{{ item.name }}</td>
                                                @if(item?.metadata_type === 'image'){
                                                    <td [innerHTML]="item | indexDataAttachment : indexData | safe : 'html'"></td>
                                                } @else {
                                                    <td>{{ item.value }}</td>
                                                }
                                            </ng-container>
                                        </tr>
                                    </tbody>
                                </table>
                                } }
                            </ng-container>
                        </div>
                        <!-- Document Fields -->
                        <div class="table-responsive" *ngIf="documentFields.length">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>{{ t('Document fields tab text (Document index data model) - Document fields') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for(item of documentFields; track item) {
                                        <tr>
                                            <td>
                                                <div class="d-flex flex-column justify-content-start">
                                                    <span>{{ item.value?.select_type_text }}</span>
                                                    @switch (item.value?.field_info) {
                                                        @case (fieldInfo.DOCUMENT_FIELD){
                                                            <small>{{ item.value?.meta_data?.meta_data_name }}</small>
                                                        }
                                                        @case (fieldInfo.CUSTOM_FIELD){
                                                            <small>-</small>
                                                        }
                                                    }
                                                </div>
                                            </td>
                                            <td>
                                                {{ item.value?.type === 'datepicker' ? (item.value?.value ? (item.value?.value | dateFormat | async) : '') : (item.value?.value ?? '') }}
                                            </td>
                                        </tr>
                                    } @empty {
                                        <tr>
                                            <td>{{ t('Documents fields are empty text (Document index data model) - Documents fields are empty') }}</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>

                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>{{ t('Sender Details tab text (Document index data model) - Sender Details') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{ t('Name (general) - Name') }}</td>
                                        <td>{{ indexData?.template?.user?.name }}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ t('Email (general) - Email') }}</td>
                                        <td>{{ indexData?.template?.user?.email }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>{{ t('Account Details tab text (Document index data model) - Account Details') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{ t('Company (general) - Company') }}</td>
                                        <td>{{ indexData?.template?.user?.profile_details?.organization }}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ t('Reg no (general) - Reg no') }}</td>
                                        <td>{{ indexData?.template?.user?.profile_details?.registration_number }}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ t('Phone no (general) - Phone no') }}</td>
                                        <td>{{ indexData?.template?.user?.phone }}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ t('Zip code (general) - Zip code') }}</td>
                                        <td>{{ indexData?.template?.user?.profile_details?.zipcode }}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ t('City (general) - City') }}</td>
                                        <td>{{ indexData?.template?.user?.profile_details?.city }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- product table and summary index data start here -->
                        <ng-container *ngIf="indexData?.template_fields_datas?.data?.blocks">
                            <div class="table-responsive">
                                <table class="table" *ngFor="let productTable of indexData.template_fields_datas.data.blocks | filterBlock : 'product-table'">
                                    <thead>
                                        <tr>
                                            <th>{{ productTable?.name }}</th>
                                        </tr>
                                    </thead>
                                    <tbody *ngIf="productTable?.table">
                                        <ng-container *ngFor="let product of productTable.table">
                                            <tr>
                                                <td colspan="2"><b>{{ product?.product_name }}</b></td>
                                            </tr>
                                            <tr *ngIf="product?.description">
                                                <td colspan="2">{{ product?.description }}</td>
                                            </tr>
                                            <tr>
                                                <td>{{ productTable?.labels?.quantity }}</td>
                                                <td>{{ product?.qty }}</td>
                                            </tr>
                                            <tr>
                                                <td>{{ t("Product form Price field (Product library) - Price") }}</td>
                                                <td>{{ product?.price }} {{ product?.currency }} / {{ product?.billing_frequency_label }}</td>
                                            </tr>
                                            <tr>
                                                <td>{{ productTable?.labels?.terms }}</td>
                                                <td>{{ product?.terms }}</td>
                                            </tr>
                                            <tr *ngIf="product?.qty && product.qty > 1">
                                                <td>{{ t("Total data design label (Summary settings) - Total") }}</td>
                                                <td>{{ product?.total }} {{ product?.currency }} / {{ product?.billing_frequency_label }}</td>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                            <div class="table-responsive">
                                <table class="table" *ngFor="let summary of indexData.template_fields_datas.data.blocks | filterBlock : 'product-table-summary'">
                                    <thead>
                                        <tr>
                                            <th>{{ summary?.name }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{{ summary?.labels?.quantity }}</td>
                                            <td>{{ summary?.total_qty }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ summary?.labels?.pricepermonth }}</td>
                                            <td>{{ summary?.contract_values?.netPerMonth }} {{ summary?.currency }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ summary?.labels?.onetimecost }}</td>
                                            <td>{{ summary?.contract_values?.netOneTime }} {{ summary?.currency }}</td>
                                        </tr>
                                        <tr *ngIf="summary?.discount_settings && summary?.discount_settings?.value > 0">
                                            <td>{{ summary?.labels?.discount }}</td>
                                            <td>{{ summary.discount_settings | summaryTaxDiscountFormat : summary?.currency : 'discount' }}</td>
                                        </tr>
                                        <tr *ngIf="summary?.tax_settings && summary?.tax_settings?.value > 0">
                                            <td>{{ summary?.labels?.tax }}</td>
                                            <td>{{ summary.tax_settings | summaryTaxDiscountFormat : summary?.currency : 'tax' }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ t("Total data design label (Summary settings) - Total") }}</td>
                                            <td *ngIf="summary?.contract_values as cv">
                                                <ng-container *ngIf="cv.totalPerMonth > 0">
                                                    {{ cv.totalPerMonth }} {{ summary?.currency }}
                                                    {{ t("Total per month text (Summary settings) - per month") }}
                                                </ng-container>
                                                <ng-container *ngIf="cv.totalPerMonth > 0 && cv.totalOneTime > 0">
                                                    +
                                                </ng-container>
                                                <ng-container *ngIf="cv.totalOneTime > 0">
                                                    {{ cv.totalOneTime }} {{ summary?.currency }}
                                                </ng-container>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </ng-container>
                        <!-- product table and sumamry index data end here -->

                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>{{ t('Document Details tab text (Document index data model) - Document Details') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngIf="indexData?.template_details?.template_id">
                                        <td>{{ t('Template name - field title (general) - Template name') }}</td>
                                        <td>{{ indexData?.template?.template?.name }}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ t('Document name (general) - Document name') }}</td>
                                        <td>{{ indexData?.template_details?.visible_name ? indexData?.template_details?.visible_name : indexData?.template?.name }}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ t('Document id (general) - Document id') }}</td>
                                        <td>{{ indexData?.template_details?.id }}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ t('Document index data modal column - (Document index data) - Document owner') }}</td>
                                        <td (dblclick)="showOwners()" *ngIf="!isOwnerEditable">{{ indexData?.template?.user?.name }}</td>
                                        <td *ngIf="isOwnerEditable">
                                            <ng-select
                                                #docField
                                                (close)="isOwnerEditable = false"
                                                (change)="changeOwner()"
                                                [(ngModel)]="selectedOwner"
                                                [items]="workSpaceUsers"
                                                bindLabel="name"
                                                bindValue="id"
                                                [readonly]="false"
                                                [searchable]="true"
                                                [placeholder]="t('document listing - document details sidebar - index data - select owner placeholder')"
                                            ></ng-select>
                                        </td>
                                    </tr>
                                    <tr *ngIf="indexData?.template_details?.template_id">
                                        <td>{{ t('Template id (general) - Template id') }}</td>
                                        <td>{{ indexData?.template_details?.template_id }}</td>
                                    </tr>
                                    @if(indexData?.template?.document_type){
                                    <tr>
                                        <td>{{ t('Document type label (general) - Document type') }}</td>
                                        <td>{{ indexData?.template?.document_type?.document_type }}</td>
                                    </tr>
                                    } @if(indexData?.template?.category){
                                    <tr>
                                        <td>{{ indexData?.template?.category?.parent_category === 0 ? t('Category (general) - Category') : t('Sub Category (general) - Sub Category') }}</td>
                                        <td>{{ indexData?.template?.category?.category_name }}</td>
                                    </tr>
                                    }
                                    <tr>
                                        <td>{{ t('Language (general) - Language') }}</td>
                                        <td>{{ indexData?.template_details?.language }}</td>
                                    </tr>
                                    <tr *ngIf="indexData?.template_details?.status  === documentStatusEnum.SIGNED">
                                        <td>{{ t('Signed date (general) - Signed date') }}</td>
                                        <td>{{ indexData?.template_details?.status_updated_at | dateFormat | async }}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ t('Due date (general) - Due date') }}</td>
                                        <td>{{ indexData?.template_details?.due_date | dateFormat | async }}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ t('Status (general) - Status') }}</td>
                                        <td>{{ indexData?.template?.status }}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ t('Pdf (general) - Pdf') }}</td>
                                        <td>
                                            <a href="{{ indexData?.template_details?.pdf_path }}" class="text-primary" target="_blank">{{ (indexData$ | async)?.template_details?.pdf_path }}</a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{ t('Document url (general) - Document url') }}</td>
                                        <td>
                                            <a
                                                href="{{ currentUrl }}sender/{{ (indexData?.template_roles | extractSenderDetailPipe)?.id }}/{{ (indexData?.template_roles | extractSenderDetailPipe)?.recipient_role_detail?.unique_id }}"
                                                class="text-primary"
                                                target="_blank"
                                            >
                                                {{ currentUrl }}sender/{{ ((indexData$ | async)?.template_roles | extractSenderDetailPipe)?.id }}/{{ ((indexData$ | async)?.template_roles |
                                                extractSenderDetailPipe)?.recipient_role_detail?.unique_id }}
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </ng-scrollbar>
    </div>
</ng-container>
